import { connect } from 'react-redux'
import { Action, Dispatch } from 'redux'

import Component, { Props, Actions } from '../../platform/components/Breadcrumbs'
import { Breadcrumb } from '../../platform/types'
import { HOME_BREADCRUMB } from '../../platform/content'
import { navigateToTab } from '../../platform/actions'

const mapStateToProps = (): Props => {
	return {
		breadcrumbs: [
			HOME_BREADCRUMB,
			{ title: 'Contact Us', isClickable: false },
		],
	}
}

const mapDispatchToProps = (dispatch: Dispatch<Action>): Actions => ({
	onBreadcrumbClick: (breadcrumb: Breadcrumb) => {
		switch (breadcrumb.type) {
			default:
				dispatch(navigateToTab({ tab: 'home' }))
				break
		}
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)